export default __webpack_public_path__ + "static/media/ebed_menu_gomb.90df01a2.png";